<div *ngIf="guest?.primaryEmail">{{ guest?.primaryEmail | truncate: 25 }}</div>
<div *ngIf="guest?.phone">{{ guest?.phone }}</div>
<div [innerHTML]="guest?.address | address: true"></div>
